import React from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const products = [
  { name: "Shrava360", logo: "/img/hrms200.png", href: "/Shrava360", tag: "Human Resource Management System" },
  { name: "Lauratek", logo: "/img/111.png", href: "/Lauratek", tag: "Learning Management System" },
  { name: "Logsphere", logo: "/img/85.png", href: "/Logsphere", tag: "Workforce Monitoring System" },
  { name: "Rob n Grab", logo: "/img/93.png", href: "/RobnGrab", tag: "Recruitment & Onboarding" },
  { name: "OneStep Medi", logo: "/img/103.png", href: "/one_step_medi", tag: "All-in-One Healthcare System" },
  { name: "Lauratek v2.0", logo: "/img/48.png", href: "/Lauratek2.0", tag: "Learning Management System" },
  { name: "Devtalent", logo: "/img/37.png", href: "/Devtalent", tag: "Talent Evaluation Platform" },
  { name: "Hisphere", logo: "/img/213.png", href: "/Hisphere", tag: "Recruitment & Onboarding" },
  { name: "Vishan", logo: "/img/63.png", href: "/Vishan", tag: "School Management System" },
  { name: "Arogya Narayan", logo: "/img/53.png", href: "/ArogyaNarayan", tag: "Hospital Management System" },
];

const Products = () => {
  return (
    <section className="relative py-14 sm:py-10 bg-gradient-to-b from-gray-50/60 to-white text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-8 sm:mb-10">
          <div className="inline-flex items-center gap-2 mb-2">
            {/* <span className="relative inline-flex">
              <span className="w-5 h-5 rounded-full border-2 border-blue-500" />
              <span className="absolute -bottom-1 -right-1 w-2 h-2 rounded-full bg-blue-500" />
            </span> */}
            <div className="flex flex-column">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-800">
                Our <span className="text-gray-900">Products</span>

              </h2>
              <p>Our digital products are built to solve real-world business challenges by improving efficiency, automation and user experience through smart technology.</p>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {products.map((p, index) => (
            <motion.div
              key={`${p.name}-${index}`}
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="group h-full min-h-[240px] no-underline rounded-[22px] border border-gray-200/70
                         bg-gradient-to-b from-white to-gray-50
                         hover:shadow-blue-500/50
                         shadow-xl
                         px-6 sm:px-8 py-6
                         flex flex-col items-center justify-between text-center gap-3 relative"
            >
              <Link 
                to={p.href}
                className="absolute inset-0 z-10"
              />

              <img
                src={p.logo}
                alt={p.name}
                className="h-14 sm:h-20 w-auto object-contain mt-2"
                loading="lazy"
              />

              <span className="text-lg sm:text-xl -mb-2 font-semibold text-gray-800">
                {p.name}
              </span>

              {/* LONG DIVIDER */}
              <div className="w-24 h-px bg-gray-300 my-1" />

              {/* TAG AT BOTTOM – NO BG, JUST TEXT */}
              <span className="text-xs font-medium text-black ">
                {p.tag}
              </span>

            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Products;
